var Pagination = require('./compiled/Pagination');
var PaginationEvent = require('./compiled/bus');

module.exports = {
  Pagination:Pagination,
  PaginationEvent:PaginationEvent
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-pagination-2/index.js
// module id = 544
// module chunks = 0